export enum CategoryEnum{
    country = 1,
    post = 2,
  }